import jump from 'jump.js'

export default hideCollectionJump => {
  const stickyButton = document.querySelector('.see-full-cta')
  const seeCollection = document.querySelector('.see-full-collection')
  let container = document.querySelector('.collection-container')
  seeCollection.addEventListener('click', () => {
    if (container.classList.contains('closed')) {
      stickyButton.style = 'position: sticky; bottom: 60px; text-align:center; padding-top: 30px;'
      seeCollection.classList.add('open')
      container.classList.remove('closed')
      container.classList.remove('build-transparency')
      container.classList.add('open')
      container.style = 'transition:max-height 0.8s ease-in; max-height: 10000px;'
      seeCollection.innerHTML = 'Hide Collection <span class="arrow-up"></span></span>'
    } else {
      container.classList.remove('open')
      container.classList.add('closed')
      container.classList.add('build-transparency')
      seeCollection.classList.remove('open')
      stickyButton.style = 'text-align:center; padding-top: 30px;'
      container.style = 'max-height: 750px; overflow: hidden;'
      seeCollection.innerHTML = 'See full collection <span class="arrow-down"></span></span>'
      jump('.collection-container', { offset: -150, duration: 100 })
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/hide-build-collection-jump.js